export const Paths = {
  Home: '/',
  LoadGroups: '/load-groups',
  Container: '/container'
};
